import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Input, Form, Button, notification, Flex } from 'antd';
import { jwtDecode } from 'jwt-decode';

import { exception } from '@extensions/notification';
import { userLoaded, initWarehouseType } from '@store/actions';
import { isNewYearAroundUs } from '@extensions/utils';

import { serverFetch } from '@src/server';
import { MainLogoIcon } from '@icons/index';

import { IUserSession } from '@core/entities/user-session';
import { BusinessUnit } from '@core/enums/business-unit';

import FreshLineCuttingBotQr from '@assets/img/FreshLineCuttingBotQr.png';
import FreshLinePlantingBotQr from '@assets/img/FreshLinePlantingBotQr.png';

import '@core/auth.css';

interface IAuth {
    appVersion: string | undefined;
}

interface IAuthParams {
    signInLogin: string;
    password: string;
}

const Auth = (props: IAuth) => {
    const { appVersion } = props;

    const warehouseName = process.env.REACT_APP_WHS_NAME;

    const d = useDispatch();

    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();

    const [loading, setLoading] = useState(false);
    const [ipAddress, setIpAddress] = useState<string>();

    useEffect(() => {
        getIpAddress();

        document.addEventListener('keydown', onKeyDown, false);
        return () => {
            document.removeEventListener('keydown', onKeyDown, false);
            close();
        };
    }, []);

    const getIpAddress = async () => {
        fetch('https://api.ipify.org/?format=json')
            .then((res: any) => res.json())
            .then((data: any) => {
                setIpAddress(data?.ip);
            })
            .catch((ex) => {});
    };

    const onKeyDown = (e: any) => {
        if (e.keyCode === 13) {
            //signInForm.submit();
        }
    };

    const close = () => {
        setLoading(false);
        form.resetFields();
    };

    const onFinish = (entity: IAuthParams) => {
        setLoading(true);

        const data = { login: entity.signInLogin, password: entity.password, ipAddress: ipAddress };

        serverFetch(`auth/signin`, { method: 'POST', bodyData: data, credentials: 'include' })
            .then((data) => {
                window.accessToken = data.accessToken;
                localStorage.setItem('refreshToken', data.refreshToken);

                const result: any = jwtDecode(data.accessToken);

                const userSession: IUserSession = {
                    businessUnit: BusinessUnit.Cutting,
                    userId: result.userId,
                    type: result.type,
                    fullName: result.fullName,
                    permissions: JSON.parse(result.permissions),

                    useTagRequired: false,
                };

                d(userLoaded(userSession));
                d(initWarehouseType(data.warehouseType));

                close();
            })
            .catch((ex) => {
                setLoading(false);
                exception(api, 'Ошибка авторизации', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <div className='auth'>
            <Flex className='auth-container' vertical justify='space-between' align='center'>
                <div className='auth-form'>
                    <div className='auth-whs-name'>{warehouseName}</div>

                    <div className='auth-logo'>
                        {isNewYearAroundUs() && <div style={{ top: 86 }} className='santa-hat-auth'></div>}
                        <MainLogoIcon style={{ fontSize: 64 }} />
                    </div>

                    <div className='auth-form-title'>Личный кабинет</div>

                    <Form size={'large'} form={form} initialValues={{ remember: true }} onFinish={onFinish}>
                        <Form.Item
                            name='signInLogin'
                            rules={[{ required: true, message: 'Пожалуйста введите логин' }]}
                            hasFeedback
                            className='auth-form-item'
                        >
                            <Input name='signInLogin' placeholder='Логин' disabled={loading} className='auth-form-item-input' />
                        </Form.Item>
                        <Form.Item
                            name='password'
                            className='auth-form-item'
                            rules={[{ required: true, message: 'Пожалуйста введите пароль' }]}
                            hasFeedback
                        >
                            <Input.Password name='password' placeholder={'Пароль'} disabled={loading} className='auth-form-item-input' />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button type='primary' htmlType='submit' loading={loading} className='auth-form-btn'>
                                Войти
                            </Button>
                        </Form.Item>

                        <Form.Item style={{ marginTop: 40, textAlign: 'center' }}>
                            <a href='https://t.me/FreshLineCuttingBot' target='_blank'>
                                <img style={{ width: 170 }} alt='Доступно в Telegram' src={FreshLineCuttingBotQr} />
                            </a>
                        </Form.Item>
                    </Form>
                </div>
                <div className='auth-app-version'>Версия {appVersion}</div>
            </Flex>

            {contextHolder}
        </div>
    );
};

export default Auth;
